"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * This CSS is based on 18F's `.sr-only` class (https://accessibility.18f.gov/hidden-content/)
 **/
var HiddenElement = _styledComponents.default.span(_templateObject());

var VisuallyHidden = function VisuallyHidden(_ref) {
  var children = _ref.children,
      tag = _ref.tag,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "tag"]);
  return /*#__PURE__*/_react.default.createElement(HiddenElement, (0, _extends2.default)({
    as: tag
  }, rest), children);
};

VisuallyHidden.displayName = 'VisuallyHidden';
VisuallyHidden.propTypes = {
  /** The visually hidden text */
  children: _propTypes.default.node.isRequired,

  /** We usually want to wrap the hidden content in a span.
   * However, the styled-components `as` polymorphic prop allows us to render different HTML elements if necessary.
   */
  tag: _propTypes.default.string
};
VisuallyHidden.defaultProps = {
  tag: null
};
var _default = VisuallyHidden;
exports.default = _default;